(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["es-finisher"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';
    function initXsell(root) {
      var btn = root.querySelector('[data-es-xsell-add]');
      var status = root.querySelector('[data-es-xsell-status]');
      if (!btn || btn.esBound) return;
      btn.esBound = true;
      btn.addEventListener('click', function () {
        if (!window.EsCart || btn.getAttribute('aria-busy') === 'true' || btn.getAttribute('aria-disabled') === 'true') return;
        var id = parseInt(btn.getAttribute('data-variant-id'), 10);
        var qty = parseInt(btn.getAttribute('data-qty'), 10) || 1;
        btn.setAttribute('aria-busy', 'true');
        btn.textContent = root.getAttribute('data-adding');
        if (status) { status.textContent = ''; status.removeAttribute('data-state'); }
        window.EsCart.add([{ id: id, quantity: qty }], { sectionsUrl: root.getAttribute('data-product-url') })
          .then(function () {
            btn.removeAttribute('aria-busy');
            btn.setAttribute('aria-disabled', 'true');
            btn.classList.add('es-btn--disabled');
            btn.textContent = root.getAttribute('data-added');
          })
          .catch(function () {
            btn.removeAttribute('aria-busy');
            btn.textContent = btn.getAttribute('data-label');
            if (status) { status.textContent = root.getAttribute('data-error'); status.setAttribute('data-state', 'error'); }
          });
      });
    }
    function init() {
      var roots = document.querySelectorAll('[data-es-xsell]');
      for (var i = 0; i < roots.length; i++) initXsell(roots[i]);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["es-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    function money(cents) {
      return '$' + (cents / 100).toFixed(2);
    }
    function moneyShort(cents) {
      var s = money(cents);
      return s.replace(/\.00$/, '');
    }
    function fill(tpl, map) {
      return Object.keys(map).reduce(function (out, key) {
        return out.split('[' + key + ']').join(map[key]);
      }, tpl || '');
    }

    function EsProduct(root) {
      this.root = root;
      this.form = root.querySelector('[data-es-form]');
      if (!this.form) return;
      this.tiers = Array.prototype.slice.call(root.querySelectorAll('[data-es-tier]'));
      this.variants = Array.prototype.slice.call(root.querySelectorAll('[data-es-variant]'));
      this.priceNow = root.querySelector('[data-es-price-now]');
      this.priceWas = root.querySelector('[data-es-price-was]');
      this.pricePer = root.querySelector('[data-es-price-per]');
      this.addBtn = root.querySelector('[data-es-add]');
      this.addLabel = root.querySelector('[data-es-add-label]');
      this.status = root.querySelector('[data-es-status]');
      this.instalment = root.querySelector('[data-es-instalment]');
      this.actions = root.querySelector('[data-es-actions]');
      this.soldout = root.querySelector('[data-es-soldout]');
      this.sticky = root.querySelector('[data-es-sticky]');
      this.stickyTitle = root.querySelector('[data-es-sticky-title]');
      this.stickyMeta = root.querySelector('[data-es-sticky-meta]');
      this.stickyAdd = root.querySelector('[data-es-sticky-add]');
      this.cfg = root.dataset;
      this.nightsPerPack = parseInt(this.cfg.nightsPerPack, 10) || 30;

      var initial = root.querySelector('[data-es-initial]');
      try {
        this.initial = JSON.parse(initial ? initial.textContent : '{}');
      } catch (e) {
        this.initial = {};
      }
      this.unit = parseInt(this.initial.unit, 10) || 0;

      this.bindTiers();
      this.bindVariants();
      this.bindSubmit();
      this.bindSticky();
      this.bindGallery();
      this.applyTier(false);
    }

    EsProduct.prototype.selectedTier = function () {
      for (var i = 0; i < this.tiers.length; i++) {
        if (this.tiers[i].checked) return this.tiers[i];
      }
      return this.tiers[0] || null;
    };

    EsProduct.prototype.selectedVariant = function () {
      for (var i = 0; i < this.variants.length; i++) {
        var v = this.variants[i];
        if (v.type === 'hidden' || v.checked) return v;
      }
      return this.variants[0] || null;
    };

    /* Same arithmetic as the Liquid at render time, so a variant change recomputes every tier. */
    EsProduct.prototype.compute = function (tier) {
      var qty = parseInt(tier.dataset.qty, 10) || 1;
      var paid = parseInt(tier.dataset.paid, 10) || 1;
      var price = this.unit * paid;
      var was = this.unit * qty;
      var nights = qty * this.nightsPerPack;
      var perPack = Math.round(price / qty);
      var perNight = Math.round(price / nights);
      var instal = Math.round(price / 4);
      var perNightText = perNight >= 100
        ? moneyShort(perNight) + ' ' + this.cfg.perNightSuffix
        : perNight + 'c ' + this.cfg.perNightSuffix;
      return {
        qty: qty,
        price: price,
        priceMoney: money(price),
        wasMoney: money(was),
        meta: qty + ' ' + this.cfg.packsWord + '. ' + nights + ' ' + this.cfg.nightsWord + '.',
        rate: moneyShort(perPack) + ' ' + this.cfg.perPackSuffix + ', ' + perNightText,
        perNightText: perNightText,
        button: fill(this.cfg.addLabelTpl, { packs: qty, price: money(price) }),
        success: fill(this.cfg.successTpl, { packs: qty, price: money(price) }),
        instalment: fill(this.cfg.instalmentTpl, { amount: money(instal) }),
        title: tier.dataset.title
      };
    };

    EsProduct.prototype.renderTierRows = function () {
      var self = this;
      this.tiers.forEach(function (tier) {
        var c = self.compute(tier);
        var label = tier.closest('label');
        if (!label) return;
        var p = label.querySelector('[data-es-tier-price]');
        var w = label.querySelector('[data-es-tier-was]');
        var m = label.querySelector('[data-es-tier-meta]');
        var r = label.querySelector('[data-es-tier-rate]');
        if (p) p.textContent = c.priceMoney;
        if (w) {
          w.innerHTML = '';
          var sr = document.createElement('span');
          sr.className = 'es-visually-hidden';
          sr.textContent = self.cfg.anchorPrefix + ' ';
          w.appendChild(sr);
          w.appendChild(document.createTextNode(c.wasMoney));
        }
        if (m) m.textContent = c.meta;
        if (r) r.textContent = c.rate;
      });
    };

    EsProduct.prototype.applyTier = function (recompute) {
      var tier = this.selectedTier();
      if (!tier) return;
      if (recompute) this.renderTierRows();
      var c = this.compute(tier);
      if (this.priceNow) this.priceNow.textContent = c.priceMoney;
      if (this.priceWas) {
        this.priceWas.innerHTML = '';
        var sr = document.createElement('span');
        sr.className = 'es-visually-hidden';
        sr.textContent = this.cfg.anchorPrefix + ' ';
        this.priceWas.appendChild(sr);
        this.priceWas.appendChild(document.createTextNode(c.wasMoney));
      }
      if (this.pricePer) this.pricePer.textContent = c.perNightText;
      if (this.addLabel) this.addLabel.textContent = c.button;
      if (this.instalment) this.instalment.textContent = c.instalment;
      if (this.stickyTitle) this.stickyTitle.textContent = c.title;
      if (this.stickyMeta) this.stickyMeta.textContent = c.meta;
      if (this.stickyAdd) this.stickyAdd.textContent = c.button;
      this.clearStatus();

      var nudges = this.root.querySelectorAll('[data-es-nudge-for]');
      for (var i = 0; i < nudges.length; i++) {
        nudges[i].hidden = nudges[i].getAttribute('data-es-nudge-for') !== tier.id;
      }
    };

    EsProduct.prototype.bindTiers = function () {
      var self = this;
      this.tiers.forEach(function (tier) {
        tier.addEventListener('change', function () { self.applyTier(false); });
      });
    };

    EsProduct.prototype.bindVariants = function () {
      var self = this;
      this.variants.forEach(function (v) {
        if (v.type !== 'radio') return;
        v.addEventListener('change', function () {
          self.unit = parseInt(v.dataset.price, 10) || self.unit;
          var available = v.dataset.available === 'true';
          if (self.actions) self.actions.hidden = !available;
          if (self.soldout) self.soldout.hidden = available;
          if (self.sticky) self.sticky.hidden = !available;
          self.applyTier(true);
        });
      });
    };

    EsProduct.prototype.setStatus = function (text, isError) {
      if (!this.status) return;
      this.status.textContent = text || '';
      if (isError) {
        this.status.setAttribute('data-state', 'error');
      } else {
        this.status.removeAttribute('data-state');
      }
    };
    EsProduct.prototype.clearStatus = function () {
      this.setStatus('', false);
    };

    EsProduct.prototype.setBusy = function (busy, label) {
      if (this.addBtn) {
        if (busy) {
          this.addBtn.setAttribute('aria-busy', 'true');
          this.addBtn.setAttribute('aria-disabled', 'true');
        } else {
          this.addBtn.removeAttribute('aria-busy');
          this.addBtn.removeAttribute('aria-disabled');
        }
      }
      if (this.addLabel && label !== undefined) this.addLabel.textContent = label;
      if (this.stickyAdd && label !== undefined) this.stickyAdd.textContent = label;
    };

    EsProduct.prototype.bindSubmit = function () {
      var self = this;
      this.form.addEventListener('submit', function (event) {
        if (!window.EsCart || typeof window.EsCart.add !== 'function') return;
        event.preventDefault();
        if (self.addBtn && self.addBtn.getAttribute('aria-busy') === 'true') return;
        var tier = self.selectedTier();
        var variant = self.selectedVariant();
        if (!tier || !variant) return;
        var c = self.compute(tier);
        self.setBusy(true, self.cfg.addingLabel);
        self.clearStatus();
        window.EsCart.add(
          [{ id: parseInt(variant.value, 10), quantity: c.qty }],
          { sectionsUrl: self.cfg.productUrl }
        ).then(function () {
          self.setBusy(false, c.button);
          self.setStatus(c.success, false);
        }).catch(function () {
          self.setBusy(false, c.button);
          self.setStatus(self.cfg.errorText, true);
        });
      });
    };

    EsProduct.prototype.bindSticky = function () {
      if (!this.sticky || !this.addBtn || !('IntersectionObserver' in window)) return;
      var self = this;
      var mq = window.matchMedia('(min-width: 1024px)');
      var io = new IntersectionObserver(function (entries) {
        var en = entries[0];
        var passed = !mq.matches && !en.isIntersecting && en.boundingClientRect.top < 0;
        self.sticky.classList.toggle('is-visible', passed);
        self.sticky.setAttribute('aria-hidden', passed ? 'false' : 'true');
        if (self.stickyAdd) self.stickyAdd.tabIndex = passed ? 0 : -1;
        document.body.classList.toggle('es-has-sticky', passed);
      }, { threshold: 0 });
      io.observe(this.addBtn);
    };

    EsProduct.prototype.bindGallery = function () {
      var gallery = this.root.querySelector('[data-es-gallery]');
      if (!gallery) return;
      var track = gallery.querySelector('[data-es-track]');
      var slides = Array.prototype.slice.call(gallery.querySelectorAll('[data-es-slide]'));
      var counter = gallery.querySelector('[data-es-counter]');
      var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-es-thumb]'));
      var prev = gallery.querySelector('[data-es-prev]');
      var next = gallery.querySelector('[data-es-next]');
      if (!track || slides.length < 2) return;
      var current = 0;

      function goTo(i) {
        i = Math.max(0, Math.min(slides.length - 1, i));
        track.scrollTo({ left: slides[i].offsetLeft - slides[0].offsetLeft, behavior: 'smooth' });
      }
      function setCurrent(i) {
        if (i === current) return;
        current = i;
        if (counter) counter.textContent = (i + 1) + ' / ' + slides.length;
        thumbs.forEach(function (t, k) {
          if (k === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
        });
        if (prev) prev.setAttribute('aria-disabled', i === 0 ? 'true' : 'false');
        if (next) next.setAttribute('aria-disabled', i === slides.length - 1 ? 'true' : 'false');
      }
      if (prev) {
        prev.setAttribute('aria-disabled', 'true');
        prev.addEventListener('click', function () { goTo(current - 1); });
      }
      if (next) next.addEventListener('click', function () { goTo(current + 1); });
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { goTo(parseInt(t.getAttribute('data-es-thumb'), 10)); });
      });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current - 1); }
      });
      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          var w = slides[0].offsetWidth + 8;
          setCurrent(Math.round(track.scrollLeft / w));
          ticking = false;
        });
      }, { passive: true });
    };

    function init() {
      var roots = document.querySelectorAll('[data-es-product]');
      for (var i = 0; i < roots.length; i++) {
        if (!roots[i].esProduct) roots[i].esProduct = new EsProduct(roots[i]);
      }
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
